import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Observable, take} from 'rxjs';
import {depotsFeature, DepotState} from "../state/depots.state";
import {DepotModel} from "../models/depot.model";
import {DepotsActions, DepotsAPIActions, DepotsChannelActions} from "../state/depots.actions";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";

@Injectable()
export class DepotsFacadeService implements EntitiesFacade<DepotModel> {

  constructor(@Inject(Store) private store: Store<DepotState>) {
  }

  subscribeToChannels(ids?: string[]): void {
    this.store.dispatch(DepotsChannelActions.subscribe({ids: ids}));
  }

  unsubscribeFromChannels(): void {
    this.store.dispatch(DepotsChannelActions.unsubscribe());
  }

  removeByIds(ids: string[]): void {
    throw new Error('Method not implemented.');
  }

  removeAll(): void {
    throw new Error('Method not implemented.');
  }

  setMany(entities: DepotModel[]): void {
    throw new Error('Method not implemented.');
  }

  setOne(entity: DepotModel): void {
    throw new Error('Method not implemented.');
  }

  updateOne(entity: DepotModel): void {
    throw new Error('Method not implemented.');
  }

  updateMany(entities: DepotModel[]): void {
    throw new Error('Method not implemented.');
  }

  selectOne(id: string): Observable<DepotModel> {
    return this.store.select(depotsFeature.selectDepot(id));
  }

  selectAll(): Observable<DepotModel[]> {
    throw new Error('Method not implemented.');
  }

  selectByIds(ids: string[]): Observable<DepotModel[]> {
    throw new Error('Method not implemented.');
  }

  selectIsLoading(): Observable<boolean> {
    throw new Error('Method not implemented.');
  }

  clearStore(): void {
    this.store.dispatch(DepotsActions.clearStore());
  }

  getOne(id: string, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(DepotsAPIActions.getDepot({id: id, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getMany(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(DepotsAPIActions.getDepots({params: params, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getInfiniteScrollEntities(params?: Object, isSubscribeToChannels?: boolean): void {
    this.store.dispatch(DepotsAPIActions.getInfiniteScrollDepots({params: params, isSubscribeToChannel: isSubscribeToChannels}));
  }

  selectInfiniteScrollEntities(): Observable<DepotModel[]> {
    return this.store.select(depotsFeature.selectInfiniteScrollDepots());
  }

  selectInfiniteScrollLoadingState(): Observable<boolean> {
    return this.store.select(depotsFeature.selectIsInfiniteScrollLoading());
  }

  fetchNext(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.select(depotsFeature.selectCursor()).pipe(take(1)).subscribe((cursor) => {
      if (!!cursor) {
        this.store.dispatch(DepotsAPIActions.getInfiniteScrollDepots({params: params, isSubscribeToChannel: isSubscribeToChannel}));
      }
    })
  }

  createOne(depot: DepotModel): void {
    this.store.dispatch(DepotsAPIActions.createDepot({depot: depot}));
  }

  editOne(id: string, depot: DepotModel): void {
    this.store.dispatch(DepotsAPIActions.updateDepot({id: id, depot: depot}));
  }

  deleteOne(id: string): void {
    this.store.dispatch(DepotsAPIActions.deleteDepot({id: id}));
  }


}
